import {
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import { CommonService } from 'src/app/shared/utils/common.service';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { UserManagementService } from '../user-management.service';
import { MultiUserSelectionListComponent } from './multi-user-selection-list/multi-user-selection-list.component';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import {
  IUserGroup,
  IUserGroups,
} from '../add-user/add-user-management.interface';
import { Utility } from 'src/app/shared/utils/utility.service';
import { UserTypeRequest } from 'src/app/shared/constants/request-mapping';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-multi-user-share-access',
  templateUrl: './multi-user-share-access.component.html',
  styleUrls: ['./multi-user-share-access.component.scss'],
})
export class MultiUserShareAccessComponent implements OnInit, OnDestroy {
  @ViewChild(MultiUserSelectionListComponent) selectionListComponent:
    | MultiUserSelectionListComponent
    | undefined;

  @Input() group: any;
  @Input() isDashboard!: boolean;
  subscription: Subscription | undefined;
  sharedData?: ISharedData;
  @Input() selectedUsers: any[] = [];
  @Input() users: any[] = [];
  @Input() existingUsers: any[] = [];
  stepper!: number;
  user: any;
  formGroup!: FormGroup;
  userType!: any;
  userRoles: IUserGroups = Utility.getUserRoles(this.translate);
  filter: any = [];
  siteTimeZone: string | undefined;
  constructor(
    private sharedDataService: SharedDataService,
    public dialogRef: MatDialogRef<MultiUserShareAccessComponent>,
    private userManagementService: UserManagementService,
    private notificationService: NotificationService,
    private commonService: CommonService,
    private localizationService: LocalizationService,
    @Inject(MAT_DIALOG_DATA) private modalData: any,
    private translate: TranslateService
  ) {
    this.group = modalData?.group;
    this.isDashboard = modalData?.isDashboard;
    this.existingUsers = modalData?.users;
    this.selectedUsers = [];
    this.users = [];
    this.userType = '';
    this.stepper = 1;
  }

  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.sharedDataService.currentData.subscribe((sharedData) => {
      this.sharedData = sharedData;
      this.siteTimeZone = <string>this.sharedData?.selectedSite?.siteTimeZone;
    });

    const siteId: string =
      this.sharedData?.selectedSite?.siteId?.toString() || '';
    this.getUsersBySiteId(siteId);
  }

  submitSelectedUsers(selectedUsers: any): void {
    this.selectedUsers = selectedUsers;
  }

  submitToParent(details: any): void {
    let accessLevel!: number;
    accessLevel = 1;
    const userIds = this.selectedUsers?.map((user: any) => {
      return {
        id: user?.userId,
        accessLevel,
      };
    });
    const variables: any = {
      ...details,
      siteId: this.sharedData?.selectedSite?.siteId?.toString(),
      userGroupId: this.group?.userGroupId,
      users: userIds,
      isDashboard: this.isDashboard,
    };

    this.userManagementService?.addUsersToUserGroup(variables).subscribe({
      next: (res: any) => {
        this.notificationService?.showSuccess(
          this.commonService?.stringInterPolation(
            this.translate.instant('SUCCESSFULLY_ADDED'),
            this.translate.instant('USER_OR_USERS')
          )
        );
        this.dialogRef.close(this.selectedUsers);
        this.sharedDataService.markAll = false; // select all mark set to false before closed modal
      },
      error: (err: Error) => {
        this.notificationService?.showError(err?.message);
      },
    });
  }

  /**
   * @param buildingId selected building id
   * @description get floors and units given buildingid
   * @returns void
   */
  getUsersBySiteId(siteId: string): void {
    const skipUserType = [
      CONSTANTS.PROPERTY_MANAGER_ADMIN,
      CONSTANTS.PROPERTY_MANAGER_USER,
    ];
    this.filter = [
      { field: 'userType', value: UserTypeRequest[CONSTANTS.RESIDENT] },
      { field: 'userType', value: UserTypeRequest[CONSTANTS.INSTALLER_ADMIN] },
      { field: 'userType', value: UserTypeRequest[CONSTANTS.INSTALLER_USER] },
    ];
    this.userManagementService
      .getUsersBySite(
        siteId,
        '',
        CONSTANTS.GET_USERS_BY_SITES_OPERATION_UPDATE,
        false,
        10000,
        false,
        this.filter,
        undefined,
        undefined,
        this.group
      )
      .subscribe({
        next: (res: any) => {
          this.users = res;
          this.users = this.users.filter((outerUser: any) => {
            return !this.existingUsers?.some(
              (innerUser: any) =>
                innerUser?.id === outerUser?.userId ||
                innerUser?.userId === outerUser?.userId
            );
          });

          this.selectionListComponent?.updateUserCopy(this.users);
        },
        error: (err: Error) => {
          if (window.__dev__) console.log('MultiUser Selection List ', err);
        },
      });
  }

  closeDialog(): void {
    this.dialogRef?.close();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
